//External
import { withRouter } from "next/router";
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";
import { get_cookie, IS_WEBP_LOADED } from "utils";

//Internal
import ReservationSearchBar from "../../components/reservation-search-bar";
import MobileReservationSearchBar from "../../components/mobile-reservation-search-bar";
import falconWhiteImage from "../../public/assets/images/Falcon_wordmark_white.svg";
import falconBlackImage from "../../public/assets/images/Falcon_wordmark_black.svg";
import * as deviceObj from "react-device-detect";

/*******************
   @Purpose :  Used for home top
   @Parameter : {data,slug1}
   @Author : INIC
  *******************/
function HomeTop({ data, slug1 }) {
  const [showMenuHome, setShowMenuHome] = useState(false);
  const [convenienceText, setConvenienceText] = useState("Beverly Hills");
  const [overlay, setOverlay] = useState("");
  const [isMobileApp, setIsMobileApp] = useState("");
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const videoRef = useRef(null);

  // used for play and puse video using ref
  const bannerVideoScrollHandler = () => {
    const videoElement = videoRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            videoElement.play();
          } else {
            videoElement.pause();
          }
        });
      },
      { threshold: 0.7 } // Adjust this value based on when you want to start/pause the video
    );

    if (videoElement) {
      observer.observe(videoElement);
    }

    return () => {
      if (videoElement) {
        observer.unobserve(videoElement);
      }
    };
  };

  useEffect(() => {
    if (slug1) {
      if (slug1 == "fl") {
        setConvenienceText("Miami Beach");
      }
    }
  }, [slug1]);

  useEffect(() => {
    // Detect device type on client side
    setIsMobileDevice(deviceObj.isMobile || deviceObj.isIOS);
    setIsMobileApp(get_cookie("is_mobile_app"));
    if (isMobileApp === "yes") {
      bannerVideoScrollHandler();
    }
  }, []);

  // used for setOverlay for mobile and web
  const overlaySetHandler = () => {
    if (isMobileDevice) {
      setOverlay(data?.mobile_banner_overlay === 1 ? "banner-overlay" : "");
    } else {
      setOverlay(data?.desktop_banner_overlay === 1 ? "banner-overlay" : "");
    }
  };

  useEffect(() => {
    overlaySetHandler();
  }, [isMobileDevice]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className="">
        <section
          className={`page-banner overlay-bg position-relative ${showMenuHome ? "active" : ""
            }${overlay}`}
        >
          {/* Desktop banner */}
          <picture className="home-banner home-desktop-banner">
            {IS_WEBP_LOADED && (
              <>
                <source srcSet={data?.image?.webp_w1920} type="image/webp" />
                <source srcSet={data?.image?.jpeg_w1920} type="image/jpeg" />
              </>
            )}
            <img
              src={data?.image?.jpeg_w1920}
              width={"100%"}
              alt={data?.title}
            />
          </picture>
          {/* Mobile banner */}
          {isMobileApp !== "yes" && (
            <picture className="home-banner home-mobile-banner">
              {IS_WEBP_LOADED && (
                <>
                  <source
                    srcSet={data?.mobile_image?.webp_w1200}
                    type="image/webp"
                    alt={data?.title}
                  />
                  <source
                    srcSet={data?.mobile_image?.jpeg_w1200}
                    type="image/jpeg"
                    alt={data?.title}
                  />
                </>
              )}
              <img
                src={data?.mobile_image?.jpeg_w1200}
                width={"100%"}
                alt={data?.title}
              />
            </picture>
          )}
          {isMobileApp === "yes" && (
            <div className="exotic-video home-video">
              <div className="video-wrap banner-video">
                <video
                  ref={videoRef}
                  autoPlay
                  muted
                  playsInline
                  controls={false}
                  loop
                >
                  <source src={"/assets/banner-video.mp4"} type="video/mp4" />
                </video>
              </div>
            </div>
          )}

          <div className={`banner-content ${data?.title_position}`}>
            <div className="caption-wrap text-center">
              {/* <h1 className="text-white title font-weight-normal ff-poppins">
            {data?.title}
          </h1> */}
              <div className="banner-header-wraper">
                <div className="banner-logo-img">
                  <img
                    // src={CDN_PATH + "/logo.png"}
                    src={
                      isMobileApp === "yes"
                        ? falconWhiteImage
                        : isMobileDevice
                          ? data?.mobile_banner_logo === "white"
                            ? falconWhiteImage
                            : falconBlackImage
                          : data?.desktop_banner_logo === "white"
                            ? falconWhiteImage
                            : falconBlackImage
                    }
                    height={56}
                    width={455}
                    objectFit="contain"
                    title="Falcon car rental"
                    alt="Falcon car rental"
                  />
                </div>
              </div>

            </div>
          </div>
          <div className="main-search-container">
            <div className="reservation-search-blocks d-none d-tab-flex">
              <ReservationSearchBar />
            </div>
            <div className="mobile-reservation-search-blocks d-flex d-tab-none">
              <MobileReservationSearchBar />
            </div>
          </div>
        </section>
        {isMobileApp !== "yes" && (
          <div className="custom-container">
            <div className="homefeature-wrap">
              <h1 className="home-banner-title font-weight-normal">
                {data?.title}
              </h1>
              <div className="features-list">
                <div className="features-vp-scroll">
                  <div className="features-vp-track">
                    <div className="features-vp-item">
                      <Card className="features-vp-card">
                        <Card.Body className="d-flex flex-column p-0">
                          <h4 className="font-24 fw-500 ff-hel-med">
                            01. Bespoke
                          </h4>
                          <p className="mb-0 font-17 ff-poppins">
                            From airport and hotel deliveries to one-way road trips, every detail is arranged around your schedule.
                          </p>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="features-vp-item">
                      <Card className="features-vp-card">
                        <Card.Body className="d-flex flex-column p-0">
                          <h4 className="font-24 fw-500 ff-hel-med">
                            02. Curated
                          </h4>
                          <p className="mb-0 font-17 ff-poppins">
                            A refined selection of the latest luxury and exotic vehicles, prepared with precision before every journey.
                          </p>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="features-vp-item">
                      <Card className="features-vp-card">
                        <Card.Body className="d-flex flex-column p-0">
                          <h4 className="font-24 fw-500 ff-hel-med">
                            03. Clarity
                          </h4>
                          <p className="mb-0 font-17 ff-poppins">
                            What you see online is what you pay. Rates are based on drivers 25+ carrying full coverage auto insurance.
                          </p>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="section-divider wb-section"></div>
          </div>
        )}
      </div>
    </>
  );
}

/********************
@purpose : Connect With Redux
@Parameter : {home}
@Author : INIC
******************/
const mapStateToProps = ({ home }) => ({
  showMenu: home?.showMenu,
});
export default withRouter(connect(mapStateToProps)(HomeTop));
